/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFilesGet } from "../../funcs/llmFilesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetFileRequest$inboundSchema,
};

export const tool$llmFilesGet: ToolDefinition<typeof args> = {
  name: "llm-files-get",
  description: `Retrieve file

Returns information about a specific file.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFilesGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
